<template>
  <div class="container-fluid">
    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary btn-create"
        data-toggle="modal"
        data-target="#carouselModal"
        @click="carouselModal({ action: 'add' })"
      >
        {{ i18n("Buttons.Add") }}
      </button>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="sort" slot-scope="scope">
          <div class="text-center">
            <button
              v-if="scope.row.id !== 1"
              type="button"
              class="btn btn-outline-secondary btn-sm"
              style="margin: 0 2px"
              @click="changeSort(scope.row.Guid, 'up')"
            >
              <i class="fas fa-long-arrow-alt-up" />
            </button>
            <button
              v-if="scope.row.id !== rows.length"
              type="button"
              class="btn btn-outline-secondary btn-sm"
              style="margin: 0 2px"
              @click="changeSort(scope.row.Guid, 'down')"
            >
              <i class="fas fa-long-arrow-alt-down" />
            </button>
          </div>
        </template>
        <template slot="edit" slot-scope="scope">
          <button
            type="button"
            class="btn btn-info btn-sm"
            style="margin-right: 0.5rem"
            data-toggle="modal"
            data-target="#carouselModal"
            @click="carouselModal({ action: 'edit', data: scope.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>

        <template slot="delete" slot-scope="scope">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delModal"
            @click="banner = scope.row"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      class="modal fade"
      id="carouselModal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <ValidationObserver
          ref="carousel"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-content">
              <div class="modal-header">
                <span class="modal-title">
                  <span v-if="action === 'add'">新增</span>
                  <span v-else>編輯</span>
                </span>
              </div>
              <perfect-scrollbar class="modal-body">
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for="input-banner-name">
                      <span class="mark">*</span>
                      名稱
                    </label>
                    <input
                      type="text"
                      id="input-banner-name"
                      class="form-control"
                      maxlength="50"
                      v-model="banner.BannerName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider
                    ref="BannerPic"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for=""><span class="mark">*</span>電腦版圖片</label>
                    <img
                      v-if="computerPic"
                      class="form-control"
                      style="height: 400px; margin-bottom: 10px"
                      :src="computerPic"
                      alt=""
                    />
                    <div style="margin-bottom: 10px">
                      <span class="mark">
                        * 檔案限制：[檔名].jpg、[檔名].png </span
                      ><br />
                      <span class="mark">* 大小限制：5MB以下</span><br />
                      <span class="mark">* 僅能選取一個檔案</span><br />
                      <span class="mark">* 上傳前請確認是否符合格式</span>
                    </div>
                    <el-upload
                      ref="uploadComputer"
                      class="upload-demo"
                      action
                      accept="image/jpeg,image/png"
                      :limit="1"
                      :auto-upload="false"
                      list-type="picture"
                      :on-change="uploadFile"
                      :on-remove="removeFile"
                      :file-list="computerList"
                      v-model="banner.BannerPic"
                    >
                      <el-button
                        size="small"
                        type="primary"
                        @click="uploadType = 'computer'"
                      >
                        點擊上傳
                      </el-button>
                    </el-upload>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider
                    ref="BannerPicMobile"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for=""><span class="mark">*</span>手機版圖片</label>
                    <img
                      v-if="mobilePic"
                      class="form-control"
                      style="height: 400px; margin-bottom: 10px"
                      :src="mobilePic"
                      alt=""
                    />
                    <div style="margin-bottom: 10px">
                      <span class="mark">
                        * 檔案限制：[檔名].jpg、[檔名].png </span
                      ><br />
                      <span class="mark">* 大小限制：5MB以下</span><br />
                      <span class="mark">* 僅能選取一個檔案</span><br />
                      <span class="mark">* 上傳前請確認是否符合格式</span>
                    </div>
                    <el-upload
                      ref="uploadMobile"
                      class="upload-demo"
                      action
                      accept="image/jpeg,image/png"
                      :limit="1"
                      :auto-upload="false"
                      list-type="picture"
                      :on-change="uploadFile"
                      :on-remove="removeFile"
                      :file-list="mobileList"
                      v-model="banner.BannerPicMobile"
                    >
                      <el-button
                        size="small"
                        type="primary"
                        @click="uploadType = 'mobile'"
                      >
                        點擊上傳
                      </el-button>
                    </el-upload>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </perfect-scrollbar>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="
                    $refs.uploadComputer.clearFiles(),
                      $refs.uploadMobile.clearFiles()
                  "
                >
                  {{ i18n("Buttons.Cancel") }}
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(saveCarousel)"
                >
                  {{ i18n("Buttons.Save") }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      id="delModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">刪除</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ banner.BannerName }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delCarousel"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  data() {
    return {
      // 判斷新增、編輯
      action: "add",

      banner: {},

      // 電腦版圖片
      computerPic: null,
      computerList: [],

      //手機版圖片
      mobilePic: null,
      mobileList: [],

      // 上傳類型
      uploadType: "",

      rows: [],
      totalData: 0,

      // table data
      tableInfo: {
        // 分頁資訊
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "",
          name: "sort",
          slot_name: "sort",
        },
        {
          label: "名稱",
          name: "BannerName",
        },
        {
          label: "",
          name: "edit",
          slot_name: "edit",
        },
        {
          label: "",
          name: "delete",
          slot_name: "delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getCarousel();
    },

    // 取得 輪播
    getCarousel() {
      this.updateLoading(true);
      this.$api.frontPage
        .getCarouselPaging({
          startDate: null,
          endDate: null,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page
        })
        .then((response) => {
          if (response.status === 200) {
            this.totalData = response.data.Quantity;
            this.rows = response.data.Datas.map((item, index) => {
              return {
                id: ++index,
                ...item,
              };
            });
          }
          this.updateLoading(false);
        });
    },

    // 上傳 檔案
    uploadFile(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isLt5M) {
        this.$notify({
          title: "失敗",
          message: "圖片大小不得超過5MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        switch (this.uploadType) {
          case "computer":
            // 圖片的 base64
            this.banner.BannerPic = e.target.result;
            this.computerList = fileList;
            this.$refs.BannerPic.reset();
            break;
          case "mobile":
            // 圖片的 base64
            this.banner.BannerPicMobile = e.target.result;
            this.mobileList = fileList;
            this.$refs.BannerPicMobile.reset();
            break;
        }
      };
    },

    // 移除 檔案
    removeFile(file) {
      if (file.name === this.$refs.uploadComputer.fileList[0].name) {
        this.banner.BannerPic = null;
        this.$refs.BannerPic.syncValue();
      }
      if (file.name === this.$refs.uploadMobile.fileList[0].name) {
        this.banner.BannerPicMobile = null;
        this.$refs.BannerPicMobile.syncValue();
      }
    },

    // 輪播 Modal
    carouselModal({ action, data }) {
      switch (action) {
        case "add":
          this.banner = {};
          this.computerPic = null;
          this.mobilePic = null;
          this.action = "add";
          break;
        case "edit":
          this.banner = {
            BannerPic: data.BannerPic,
            BannerPicMobile: data.BannerPicMobile,
            BannerName: data.BannerName,
            Guid: data.Guid,
          };
          this.computerPic = data.BannerPic;
          this.mobilePic = data.BannerPicMobile;
          this.action = "edit";
          break;
      }
      this.$refs.carousel.reset();
    },

    // 新增、編輯 輪播
    saveCarousel() {
      $("#carouselModal").modal("hide");
      this.updateLoading(true);
      let message;
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.frontPage
            .postCarousel({
              ...this.banner,
              CreateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getCarousel();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.frontPage
            .putCarousel({
              ...this.banner,
              UpdateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getCarousel();
              }
              this.updateLoading(false);
            });
          break;
      }
      this.$refs.uploadComputer.clearFiles();
      this.$refs.uploadMobile.clearFiles();
    },

    // 刪除 輪播
    delCarousel() {
      this.updateLoading(true);
      this.$api.frontPage.deleteCarousel(this.banner.Guid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2000,
          });
          this.getCarousel();
        }
        this.updateLoading(false);
      });
    },

    // 變更 輪播排序
    changeSort(guid, status) {
      this.updateLoading(true);
      this.$api.frontPage
        .sortCarousel({
          BannerGuid: guid,
          Turn: status,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "排序變更成功",
              type: "success",
              duration: 2000,
            });
            this.getCarousel();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
